'use client'

import { useTranslations } from 'next-intl'
import { Controller, useFormContext } from 'react-hook-form'

import {
	PASSWORD_MAX_LENGTH,
	PASSWORD_MIN_LENGTH,
	PASSWORD_REGEX,
} from '@/constants'

import { InputFieldPassword } from './InputFieldPassword'

interface InputFieldPasswordFormProps {
	name?: string
	skipValidation?: boolean
    autoComplete?: React.HTMLInputAutoCompleteAttribute
}

export function InputFieldPasswordForm({
	name = 'password',
	skipValidation = false,
	...props
}: InputFieldPasswordFormProps) {
	const form = useFormContext()
	const t = useTranslations()
	if (!skipValidation) {
		form.register(name, {
			required: t('auth__common__input_password_validation__required'),
			pattern: {
				value: PASSWORD_REGEX,
				message: t('auth__common__input_password_validation__invalid'),
			},
			minLength: {
				value: PASSWORD_MIN_LENGTH,
				message: t('auth__common__input_password_validation__min_length'),
			},
			maxLength: {
				value: PASSWORD_MAX_LENGTH,
				message: t('auth__common__input_password_validation__max_length'),
			},
		})
	} else {
		form.register(name, {
			required: t('auth__common__input_password_validation__required'),
		})
	}

	return (
		<Controller
			control={form.control}
			name={name}
			render={({ field, fieldState }) => {
				const error = fieldState.error
					? String(fieldState.error?.message)
					: undefined
				return (
					<InputFieldPassword
						{...field}
						error={error}
						placeholder={t('auth__common__input_password_placeholder')}
						{...props}
					/>
				)
			}}
		/>
	)
}
